import { Chip } from "@mui/material";
import type { JSX } from "react";

import { LEAD_SOURCE_LABELS, leadSource } from "@xop/dashboard-shared";

/**
 * "Who found this lead" chip — the lead's origin agent (Lead Generator vs
 * Harvester). Both bots feed the one Leads pipeline, so every lead row + the
 * lead detail carry this so the operator can see, at a glance, which agent
 * produced it. Accent matches the agent identity used elsewhere in the section
 * (Harvester = info/teal, Lead Generator = brand primary).
 */
export function LeadSourceBadge({
  source,
  size = "small",
}: {
  source: string | null | undefined;
  size?: "small" | "medium";
}): JSX.Element {
  const s = leadSource(source);
  return (
    <Chip
      label={LEAD_SOURCE_LABELS[s]}
      size={size}
      variant="outlined"
      color={s === "harvester" ? "info" : "primary"}
      sx={{ borderRadius: 1, fontWeight: 500 }}
    />
  );
}
